var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"}},[_c('circle',{attrs:{"cx":"5","cy":"5","r":"5","fill":_vm.strokeColor}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }